import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_provide_kind_benefits_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'does_facility_provide_kind_benefits_line_legal_requirements',
  name: 'Does the facility provide in-kind benefits in line with legal requirements?',
  description:
    "In-kind benefits could include, e.g., transportation, meals, housing, or child care for which the cost is deducted directly from workers' wages. Payments in the form of drugs or liquor are prohibited. Wages may be paid only partly in kind since workers must have enough cash to meet their subsistence",
  meta: {
    slcpMeta: {
      key: 'wb-22--1',
      number: 'WB-WAGE-141',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-22--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35230,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
